export const filterTypes = [
  'all',
  'asset-tag',
  'customer-ticket-number',
  'cpo',
  'serial-numbers',
  'ticket-number',
  'tracking-numbers',
] as const;

export type FilterType = (typeof filterTypes)[number];

export interface GlobalSearchResults {
  serviceAddon: string;
  results: Results;
}

export interface Results {
  data: ResultsDatum[];
  total: number;
  foundFilterTypes?: FilterType[];
}

export interface ResultsDatum {
  resultType: FilterType;
  uniqueIdentifier?: string;
  navigationIdentifier?: string;
  bestPrecision: number;
  bestPrecisionKeyword: string;
  resultText: string;
  repeatedCount: number;
}

export interface ResultsDatumUI extends ResultsDatum {
  resultTextArray: string[];
}
